import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[equalizerWatcher]'
})
export class EqualizerWatcherDirective {
    @Input('equalizerWatcher')
    private _id: string | number;

    get elementRef(): ElementRef {
        return this._elementRef;
    }

    get id(): string | number {
        return this._id;
    }

    set id(value: string | number) {
        this._id = value;
    }

    constructor(
        private _elementRef: ElementRef
    ) {
    }
}
